import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { renderHtml, renderSection, loadConfig } from '@konnexsion/markpress';

import { MARKPRESS_CONFIG } from './markpress.token';

import type { RenderConfig } from '@konnexsion/markpress';

@Injectable({ providedIn: 'root' })
export class MarkpressService {
  private readonly config: RenderConfig = loadConfig(inject(MARKPRESS_CONFIG));
  private readonly doc = inject(DOCUMENT);
  private stylesInjected = false;

  injectStyles(): void {
    if (this.stylesInjected) return;
    const link = this.doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'markpress.css';
    link.setAttribute('data-markpress', '');
    this.doc.head.appendChild(link);
    this.stylesInjected = true;
  }

  renderHtml(markdown: string): string {
    return renderHtml(markdown, this.config);
  }

  renderSection(markdown: string, layout: string, inlineConfig?: Record<string, unknown>): string {
    return renderSection(markdown, layout, this.config, inlineConfig);
  }
}
